// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"76":"manage-desk","296":"electronic-file","425":"construction-data"}[chunkId] + "." + {"76":"41432b03","296":"d6dae3e2","425":"cf91295f"}[chunkId] + ".css";
};